import { axiosInstance } from "../../../api/axiosInstance.tsx";
import axios from 'axios';

export interface buildingRepairSearchParams {
  rabId?: string;
  rabName?: string;
  rabNumber?: string;
  ahsId?: string;
  ahsName?: string;
  officeId?: string;
  detailDescription?: string;
  typeOfWork?: string;
  repairCost?: number;
  reportingUserId?: string;
  volume?: number;
  reportingStatus?: string;
  duration?: number;
  paymentDate?: Date;
  startDate?: Date;
  endDate?: Date;
  repairMethod?: string;
  vendorId?: string;
  vendorName?: string;
  paymentStatus?: string;
  startDateS?: string;
  endDateS?: string;
  startDateE?: string;
  endDateE?: string;
  paymentDateStart?: string;
  paymentDateEnd?: string;
  limit?: number;
  offset?: number;
  keyword?: string;
  orderBy?: string;
  order?: string;
}

export const fetchVendors = async (): Promise<any[]> => {
  try {
    const response = await axiosInstance.get("/vendors/view_vendors");
    // Normalise the vendor data so consumer components receive
    // the common `vendorId` and `vendorName` fields
    return response.data;
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message ||
      "Gagal mengambil data vendor. Silakan coba lagi."
    );
  }
};

export const getBuildingRepairs = async (params: buildingRepairSearchParams = {}) => {
  const response = await axiosInstance.get("/building/repair/search_building_repairs", {
    params,
  });
  return response.data;
};

// Step 1: Create Vendor
export const createBuildingRepair = async (data) => {
  const payload = {
    rabName: data.rabId,
    rabNumber: data.rabNumber,
    ahsName: data.ahsId,
    officeId: data.officeId,
    detailDescription: data.detailDescription,
    typeOfWork: data.typeOfWork,
    repairCost: data.repairCost,
    reportingUserId: data.reportingUserId,
    volume: data.volume,
    reportingStatus: data.reportingStatus,
    duration: data.duration,
    paymentDate: data.paymentDate,
    startDate: data.startDate,
    endDate: data.endDate,
    repairMethod: data.repairMethod,
    vendorId:
      data.vendorId && data.vendorId !== "undefined" ? data.vendorId : undefined,
    vendorName: data.vendorName,
    paymentStatus: data.paymentStatus,
    approverName: data.approverName,
    approverPosition: data.approverPosition,
    isApprove: data.isApprove || null,
  };

  const response = await axiosInstance.post(
    `building/repair/create_building_repair`,
    payload
  );
  return response.data;
};

export const uploadBuildingRepairPhoto = async (id, type, file) => {
  const formData = new FormData();
  formData.append("file", file);

  return axiosInstance.post(
    `/building/repair/upload_file/${id}/${type}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

export const deleteBuildingRepairPhoto = async (id: string, type) => {
  try {
    await axiosInstance.delete(`/building/repair/delete_file/${id}/${type}`);
  } catch (error) {
    throw (
      error.response?.data?.message || "Terjadi kesalahan saat menghapus vendor"
    );
  }
};

export const fetchBuildingRepairPhotoBlob = async (
  filename: string
): Promise<string | null> => {
  try {
    const token = localStorage.getItem("token");

    const response = await axiosInstance.get(
      `/building/repair/file/${filename}`,
      {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    console.log(response.data);
    const objectUrl = URL.createObjectURL(response.data);
    return objectUrl;
  } catch (error) {
    console.error("Gagal mengambil foto:", error);
    return null;
  }
};

export const deleteBuildingRepair = async (id: string) => {
  try {
    await axiosInstance.delete(`/building/repair/delete_building_repair/${id}`);
  } catch (error) {
    throw (
      error.response?.data?.message || "Terjadi kesalahan saat menghapus vendor"
    );
  }
};

// Update Vendor
export const updateBuildingRepair = async (data) => {
  const payloadEdit = {
    id: data.id,
    rabName: data.rabName,
    rabNumber: data.rabNumber,
    ahsName: data.ahsName,
    officeId: data.officeId,
    detailDescription: data.detailDescription,
    typeOfWork: data.typeOfWork,
    repairCost: data.repairCost,
    reportingUserId: data.reportingUserId,
    volume: data.volume,
    reportingStatus: data.reportingStatus,
    duration: data.duration,
    startDate: data.startDate,
    endDate: data.endDate,
    paymentDate: data.paymentDate,
    repairMethod: data.repairMethod,
    vendorId:
      data.vendorId && data.vendorId !== "undefined" ? data.vendorId : undefined,
    vendorName: data.vendorName,
    paymentStatus: data.paymentStatus,
    approverName: data.approverName,
    approverPosition: data.approverPosition,
    isApprove: data.isApprove,
  };

  const response = await axiosInstance.put(
    `/building/repair/update_building_repair/${data.id}`,
    payloadEdit
  );
  return response.data;
};

// Fungsi untuk mencari vendor berdasarkan keyword
export const sesarchBuildingRepairs = async (searchQuery: string) => {
  try {
    const response = await axiosInstance.get(
      `/building/repair/search_building_repairs?keyword=${searchQuery}`
    );
    return response.data; // Pastikan response sesuai format yang diterima tabel
  } catch (error) {
    console.error("Error fetching vendors:", error);
    throw (
      error.response?.data?.message ||
      "Terjadi kesalahan saat mengambil data karyawan"
    );
  }
};

// Upload File (mengganti uploadBuildingRepairPhoto)
export const uploadBuildingRepairFile = async (id, type, file) => {
  const formData = new FormData();
  formData.append("file", file);

  return axiosInstance.post(
    `/building/repair/upload_file/${id}/${type}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

// Delete File (mengganti deleteBuildingRepairPhoto)
export const deleteBuildingRepairFile = async (id: string, type) => {
  try {
    await axiosInstance.delete(`/building/repair/delete_file/${id}/${type}`);
  } catch (error) {
    throw (
      error.response?.data?.message || "Terjadi kesalahan saat menghapus file"
    );
  }
};

// Get File (mengganti fetchBuildingRepairPhotoBlob)
export const getBuildingRepairFile = async (filename: string) => {
  try {
    const response = await axiosInstance.get(
      `/building/repair/file/${encodeURIComponent(filename)}`,
      {
        responseType: 'blob',
        headers: {
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
        }
      }
    );

    if (!(response.data instanceof Blob)) {
      throw new Error('Invalid file format received');
    }

    return {
      blob: response.data,
      filename: getFilenameFromHeaders(response.headers) || filename,
      contentType: response.headers['content-type'] || 'application/octet-stream'
    };
    
  } catch (error) {
    console.error(`Error fetching file ${filename}:`, error);
    
    if (axios.isAxiosError(error)) {
      if (error.response?.status === 404) {
        throw new Error('File not found');
      }
      if (error.response?.status === 403) {
        throw new Error('Permission denied to access this file');
      }
    }
    
    throw new Error('Failed to download file');
  }
};

// Helper function untuk extract filename
const getFilenameFromHeaders = (headers) => {
  const contentDisposition = headers['content-disposition'];
  if (!contentDisposition) return null;
  
  const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
  if (matches && matches[1]) { 
    return matches[1].replace(/['"]/g, '');
  }
  return null;
};